import React, { useCallback, useEffect, useState } from 'react';
import { useFetch } from './useFetch';

export const useUsuarios = (usePagination = true, perPage = 15) => {
  const {
    fetchData,
    data,
    loading,
    isError,
    isSuccess,
    links,
    currentPage,
    totalItems,
    perPage: actualPerPage,
    lastPage,
    from,
    to
  } = useFetch({
    isPagination: usePagination,
    initialData: []
  });
  const [searchText, setSearchText] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");

  const fetchDataUsers = useCallback((searchQuery = currentSearchQuery, page = 1) => {
    const params = new URLSearchParams();
    
    // Add pagination parameters if enabled
    if (usePagination) {
      params.append('paginate', 'true');
      if (perPage !== 15) {
        params.append('per_page', perPage.toString());
      }
    }
    
    // Add search parameter if provided
    if (searchQuery.trim()) {
      params.append('search', searchQuery.trim());
    }
    
    // Add page parameter if not the first page and pagination is enabled
    if (usePagination && page > 1) {
      params.append('page', page.toString());
    }
    
    const url = `/users${params.toString() ? `?${params.toString()}` : ''}`;
    fetchData(url, usePagination);
  }, [fetchData, currentSearchQuery, usePagination, perPage]);

  const handleSearch = useCallback(() => {
    setCurrentSearchQuery(searchText);
    fetchDataUsers(searchText, 1); // Always start from page 1 when searching
  }, [searchText, fetchDataUsers]);

  const goToPage = useCallback((page) => {
    fetchDataUsers(currentSearchQuery, page);
  }, [fetchDataUsers, currentSearchQuery]);

  const nextPage = useCallback(() => {
    if (links && Array.isArray(links)) {
      const nextLink = links.find(link => link.label === 'Next &raquo;');
      if (nextLink?.url) {
        const currentPageNum = currentPage || 1;
        goToPage(currentPageNum + 1);
      }
    }
  }, [links, currentPage, goToPage]);

  const prevPage = useCallback(() => {
    if (links && Array.isArray(links)) {
      const prevLink = links.find(link => link.label === '&laquo; Previous');
      if (prevLink?.url) {
        const currentPageNum = currentPage || 1;
        if (currentPageNum > 1) {
          goToPage(currentPageNum - 1);
        }
      }
    }
  }, [links, currentPage, goToPage]);

  return {
    fetchDataUsers,
    handleSearch,
    setSearchText,
    searchText,
    currentSearchQuery,
    users: data,
    loading,
    links,
    currentPage,
    goToPage,
    nextPage,
    prevPage,
    isError,
    isSuccess,
    usePagination,
    perPage,
    totalItems,
    actualPerPage,
    lastPage,
    from,
    to
  }
}